module.exports = __webpack_public_path__ + "static/footbed-9b306493515c5b67d1053b01283f02f0.png";